import "./App.css";
import { Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage/HomePage";
import Navbar from "./components/Navbar/Navbar";
import AboutPage from "./components/AboutPage/AboutPage";
import PortfolioPage from "./components/PortfolioPage/PortfolioPage";
import BlogPage from "./components/BlogPage/BlogPage";
import SinglePost from "./components/SinglePost/SinglePost";
import BookingPage from "./components/BookingPage/BookingPage";
import ClientLoginPage from "./components/ClientLoginPage/ClientLoginPage";
import ClientDashboard from "./components/ClientDashboard/ClientDashboard";
import Footer from "./components/Footer/Footer"; // Import Footer

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<SinglePost />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/client" element={<ClientLoginPage />} />
        <Route path="/client/:clientId" element={<ClientDashboard />} />
      </Routes>
      <Footer /> {/* Add Footer here */}
    </div>
  );
}

export default App;
